import React from 'react';

function AboutSection({ language, isVisible = false }) {
  const translations = {
    title: {
      en: 'About the Artist',
      de: 'Über die Künstlerin'
    },
    artistName: {
      en: 'Waltraud Pfister-Bläske',
      de: 'Waltraud Pfister-Bläske'
    },
    artistTagline: {
      en: 'Capturing Nature\'s Essence Through Abstract Expression',
      de: 'Die Essenz der Natur durch abstrakte Expression einfangen'
    },
    subtitle: {
      en: 'Artistic Journey',
      de: 'Künstlerischer Werdegang'
    },
    biographyPara1: {
      en: 'Based between the serene shores of Lake Starnberg and the landscapes of Italy, Waltraud Pfister-Bläske explores the boundaries between landscape and abstraction. Her paintings are a testament to her surroundings—earthy textures blending with atmospheric blues, created through dynamic, gestural strokes.',
      de: 'Zwischen den Ufern des Starnberger Sees und den Landschaften Italiens lebend, erforscht Waltraud Pfister-Bläske die Grenzen zwischen Landschaft und Abstraktion. Ihre Gemälde sind ein Zeugnis ihrer Umgebung – erdige Texturen verschmelzen mit atmosphärischen Blautönen, getragen von einem dynamischen, gestischen Pinselstrich.'
    },
    biographyPara2: {
      en: 'Her journey is one of education and exploration. With a background in Art Education from Bamberg and a tenure as an Art History lecturer at the Goethe-Institut in Paris, she brings a profound historical depth to her abstract expressionism. A dedicated educator for over three decades, she continues to exhibit her work publicly, with past showcases including the historic Schloss Garatshausen (2019).',
      de: 'Ihr Weg ist geprägt von Bildung und Entdeckung. Mit einem Hintergrund in Kunstpädagogik (Bamberg) und ihrer Zeit als Dozentin für Kunstgeschichte am Goethe-Institut in Paris verleiht sie ihrem abstrakten Expressionismus eine besondere Tiefe. Neben ihrer über 30-jährigen Tätigkeit als Kunstpädagogin präsentiert sie ihre Werke regelmäßig der Öffentlichkeit, wie etwa im Rahmen der Ausstellung im Schloss Garatshausen (2019).'
    }
  };

  return (
    <section id="about" className={`section-content ${!isVisible ? 'hidden' : ''}`}>
      <div className="container">
        <h1>{translations.title[language]}</h1>
        <div className="about-container">
          <div className="about-image" style={{ maxWidth: '350px', margin: '0 auto 20px' }}>
            <img 
              src="/images/profilepic_small.webp" 
              alt={language === 'en' 
                ? 'Waltraud Pfister-Bläske - Abstract artist from Lake Starnberg, Germany' 
                : 'Waltraud Pfister-Bläske - Abstrakte Künstlerin vom Starnberger See'
              }
              loading="lazy"
              style={{ width: '100%', height: 'auto' }} 
            />
          </div>
          
          <div className="about-content">
            <h2 className="artist-name" style={{ fontSize: '1.8em', marginBottom: '5px' }}>{translations.artistName[language]}</h2>
            <p className="artist-tagline" style={{ fontStyle: 'italic', marginBottom: '30px' }}>{translations.artistTagline[language]}</p>
            
            <h3>{translations.subtitle[language]}</h3>
            <p>{translations.biographyPara1[language]}</p>
            <p style={{ marginTop: '15px' }}>{translations.biographyPara2[language]}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
